import { render, staticRenderFns } from "./SnModal.vue?vue&type=template&id=2dd9fe81&scoped=true"
import script from "./SnModal.vue?vue&type=script&lang=js"
export * from "./SnModal.vue?vue&type=script&lang=js"
import style0 from "./SnModal.vue?vue&type=style&index=0&id=2dd9fe81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9fe81",
  null
  
)

export default component.exports